/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendCapexDto } from '../models/backend-capex-dto';
import { capexsCopyCreate } from '../fn/capexs/capexs-copy-create';
import { CapexsCopyCreate$Params } from '../fn/capexs/capexs-copy-create';
import { capexsCreate } from '../fn/capexs/capexs-create';
import { CapexsCreate$Params } from '../fn/capexs/capexs-create';
import { capexsDestroy } from '../fn/capexs/capexs-destroy';
import { CapexsDestroy$Params } from '../fn/capexs/capexs-destroy';
import { capexsList } from '../fn/capexs/capexs-list';
import { CapexsList$Params } from '../fn/capexs/capexs-list';
import { capexsPartialUpdate } from '../fn/capexs/capexs-partial-update';
import { CapexsPartialUpdate$Params } from '../fn/capexs/capexs-partial-update';
import { capexsRetrieve } from '../fn/capexs/capexs-retrieve';
import { CapexsRetrieve$Params } from '../fn/capexs/capexs-retrieve';
import { capexsUpdate } from '../fn/capexs/capexs-update';
import { CapexsUpdate$Params } from '../fn/capexs/capexs-update';

@Injectable({ providedIn: 'root' })
export class BackendApiCapexsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `capexsList()` */
  static readonly CapexsListPath = '/capexs/';

  /**
   * get object list.
   *
   * Получает список объектов, отфильтрованных по текущему пользователю и сценарию.
   *
   * :param request: Запрос от клиента.
   *
   * :return: Список объектов, отфильтрованных по текущему пользователю и сценарию.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `capexsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  capexsList$Response(
    params?: CapexsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendCapexDto>>> {
    return capexsList(this.http, this.rootUrl, params, context);
  }

  /**
   * get object list.
   *
   * Получает список объектов, отфильтрованных по текущему пользователю и сценарию.
   *
   * :param request: Запрос от клиента.
   *
   * :return: Список объектов, отфильтрованных по текущему пользователю и сценарию.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `capexsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  capexsList(params?: CapexsList$Params, context?: HttpContext): Observable<Array<BackendCapexDto>> {
    return this.capexsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendCapexDto>>): Array<BackendCapexDto> => r.body),
    );
  }

  /** Path part for operation `capexsCreate()` */
  static readonly CapexsCreatePath = '/capexs/';

  /**
   * create object.
   *
   * Создает новый объект.
   *
   * Этот метод создает новый объект с использованием данных, предоставленных клиентом.
   * Для успешного создания объекта, клиент должен предоставить `scenario_id` и авторизационный токен.
   * Пользователь присваивается объекту автоматически.
   *
   * :param request: Запрос от клиента.
   *
   * :return: Ответ с информацией о созданном объекте или сообщением об ошибке.
   *         (Внимание: пользователь должен быть автором сценария для успешного создания объекта.)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `capexsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  capexsCreate$Response(
    params: CapexsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexDto>> {
    return capexsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * create object.
   *
   * Создает новый объект.
   *
   * Этот метод создает новый объект с использованием данных, предоставленных клиентом.
   * Для успешного создания объекта, клиент должен предоставить `scenario_id` и авторизационный токен.
   * Пользователь присваивается объекту автоматически.
   *
   * :param request: Запрос от клиента.
   *
   * :return: Ответ с информацией о созданном объекте или сообщением об ошибке.
   *         (Внимание: пользователь должен быть автором сценария для успешного создания объекта.)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `capexsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  capexsCreate(params: CapexsCreate$Params, context?: HttpContext): Observable<BackendCapexDto> {
    return this.capexsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexDto>): BackendCapexDto => r.body),
    );
  }

  /** Path part for operation `capexsRetrieve()` */
  static readonly CapexsRetrievePath = '/capexs/{id}/';

  /**
   * get object data.
   *
   * Получает детальную информацию о конкретном объекте.
   *
   * Этот метод извлекает полную информацию о конкретном объекте, идентифицированном по его уникальному идентификатору (ID).
   *
   * :param request: Запрос от клиента.
   *
   * :return: Ответ, содержащий информацию о конкретном объекте.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `capexsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  capexsRetrieve$Response(
    params: CapexsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexDto>> {
    return capexsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * get object data.
   *
   * Получает детальную информацию о конкретном объекте.
   *
   * Этот метод извлекает полную информацию о конкретном объекте, идентифицированном по его уникальному идентификатору (ID).
   *
   * :param request: Запрос от клиента.
   *
   * :return: Ответ, содержащий информацию о конкретном объекте.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `capexsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  capexsRetrieve(params: CapexsRetrieve$Params, context?: HttpContext): Observable<BackendCapexDto> {
    return this.capexsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexDto>): BackendCapexDto => r.body),
    );
  }

  /** Path part for operation `capexsUpdate()` */
  static readonly CapexsUpdatePath = '/capexs/{id}/';

  /**
   * update object data.
   *
   * Обновляет информацию о конкретном объекте.
   *
   * Этот метод обновляет детальную информацию о конкретном объекте, идентифицированном по его уникальному идентификатору (ID).
   *
   * :param request: Запрос от клиента.
   *
   * :return: Ответ, содержащий обновленную информацию о конкретном объекте.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `capexsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  capexsUpdate$Response(
    params: CapexsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexDto>> {
    return capexsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * update object data.
   *
   * Обновляет информацию о конкретном объекте.
   *
   * Этот метод обновляет детальную информацию о конкретном объекте, идентифицированном по его уникальному идентификатору (ID).
   *
   * :param request: Запрос от клиента.
   *
   * :return: Ответ, содержащий обновленную информацию о конкретном объекте.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `capexsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  capexsUpdate(params: CapexsUpdate$Params, context?: HttpContext): Observable<BackendCapexDto> {
    return this.capexsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexDto>): BackendCapexDto => r.body),
    );
  }

  /** Path part for operation `capexsDestroy()` */
  static readonly CapexsDestroyPath = '/capexs/{id}/';

  /**
   * delete object.
   *
   * Удаляет конкретный объект.
   *
   * Этот метод удаляет конкретный объект, идентифицированный по его уникальному идентификатору (ID).
   *
   * :param request: Запрос от клиента.
   *
   * :return: Ответ, подтверждающий удаление объекта.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `capexsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  capexsDestroy$Response(params: CapexsDestroy$Params, context?: HttpContext): Observable<BakendHttpResponse<void>> {
    return capexsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * delete object.
   *
   * Удаляет конкретный объект.
   *
   * Этот метод удаляет конкретный объект, идентифицированный по его уникальному идентификатору (ID).
   *
   * :param request: Запрос от клиента.
   *
   * :return: Ответ, подтверждающий удаление объекта.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `capexsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  capexsDestroy(params: CapexsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.capexsDestroy$Response(params, context).pipe(map((r: BakendHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `capexsPartialUpdate()` */
  static readonly CapexsPartialUpdatePath = '/capexs/{id}/';

  /**
   * partially update object data.
   *
   * Частично обновляет информацию о конкретном объекте.
   *
   * Этот метод позволяет частично обновить детальную информацию о конкретном объекте, идентифицированном по его уникальному идентификатору (ID).
   *
   * :param request: Запрос от клиента.
   *
   * :return: Ответ, содержащий частично обновленную информацию о конкретном объекте.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `capexsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  capexsPartialUpdate$Response(
    params: CapexsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexDto>> {
    return capexsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * partially update object data.
   *
   * Частично обновляет информацию о конкретном объекте.
   *
   * Этот метод позволяет частично обновить детальную информацию о конкретном объекте, идентифицированном по его уникальному идентификатору (ID).
   *
   * :param request: Запрос от клиента.
   *
   * :return: Ответ, содержащий частично обновленную информацию о конкретном объекте.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `capexsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  capexsPartialUpdate(params: CapexsPartialUpdate$Params, context?: HttpContext): Observable<BackendCapexDto> {
    return this.capexsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexDto>): BackendCapexDto => r.body),
    );
  }

  /** Path part for operation `capexsCopyCreate()` */
  static readonly CapexsCopyCreatePath = '/capexs/copy/{id}/';

  /**
   * copy object.
   *
   * Создает копию существующего объекта.
   *
   * Этот метод создает копию существующего объекта, идентифицированного по его уникальному идентификатору (ID).
   *
   * :param request: Запрос от клиента.
   *
   * :param pk: Уникальный идентификатор объекта, который требуется скопировать.
   *
   * :return: Ответ, содержащий информацию о новой копии объекта.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `capexsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  capexsCopyCreate$Response(
    params: CapexsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexDto>> {
    return capexsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * copy object.
   *
   * Создает копию существующего объекта.
   *
   * Этот метод создает копию существующего объекта, идентифицированного по его уникальному идентификатору (ID).
   *
   * :param request: Запрос от клиента.
   *
   * :param pk: Уникальный идентификатор объекта, который требуется скопировать.
   *
   * :return: Ответ, содержащий информацию о новой копии объекта.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `capexsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  capexsCopyCreate(params: CapexsCopyCreate$Params, context?: HttpContext): Observable<BackendCapexDto> {
    return this.capexsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexDto>): BackendCapexDto => r.body),
    );
  }
}
